import { StyleSheet } from 'aphrodite';
import { THEME } from '@Theme';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.lg,
		margin: '0 auto',
		maxWidth: 720,
		padding: THEME.spacing.lg,
		width: '100%',
	},
	description: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.sm,
		margin: 0,
	},
	goalTextArea: {
		minHeight: 160,
		resize: 'vertical',
	},
	heading: {
		fontSize: THEME.typography.fontSizes.lg,
		fontWeight: THEME.typography.fontWeights.bold,
		margin: 0,
	},
	quotaCard: {
		background: THEME.colors.background.main,
		borderRadius: THEME.common.borderRadius,
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.xs,
		padding: THEME.spacing.md,
	},
	quotaExhausted: {
		color: THEME.colors.danger.main,
		fontWeight: THEME.typography.fontWeights.bold,
	},
	quotaHeadline: {
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: THEME.typography.fontWeights.bold,
		margin: 0,
	},
	quotaNote: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
		margin: 0,
	},
	researchToggleRow: {
		alignItems: 'flex-start',
		display: 'flex',
		gap: THEME.spacing.sm,
	},
	toggleCopy: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.xs,
	},
});
